import { useRouter } from 'next/router';
import { useNarrow } from './use-narrow';
import { useChatsGate } from './chats-flag';
import { CHATS_LIST_DEFAULT_WIDTH } from './use-chats-list-width';

// A full rail, a 360px list and a useful 440px transcript fit at 1080px. Below that
// Chats uses list → conversation navigation; the ordinary app breakpoint stays unchanged.
export const CHATS_SPLIT_MIN_WIDTH = 1080;
/** @deprecated The list width is now user-resizable (`use-chats-list-width.ts`); this is
 * only the pre-drag default, kept for the odd consumer that still wants a constant. */
export const CHATS_LIST_WIDTH = CHATS_LIST_DEFAULT_WIDTH;
// The list's LIVE width is mirrored onto :root as --chats-list-w by AppFrame (same pattern
// as --sidebar-w / --chat-w), so this always reflects a drag without every consumer having
// to re-render off the store directly.
export const CHATS_DOCK_WIDTH = 'calc(100vw - var(--sidebar-w, 280px) - var(--chats-list-w, 360px))';

export function useChatsLayout() {
  const { pathname } = useRouter();
  const stacked = useNarrow(CHATS_SPLIT_MIN_WIDTH);
  const { enabled } = useChatsGate();
  const onChats = enabled && pathname === '/chats';
  return { onChats, split: onChats && !stacked, stacked: onChats && stacked };
}
